module.exports = __webpack_public_path__ + "static/media/logoheto.51968d0d.png";